let map;
let markers = [];
let infoWindow;
let addresses = [];
let selectedCountry = null;

function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 45.882221, lng: -66.54296 },
    zoom: 4,
  });

  infoWindow = new google.maps.InfoWindow();

  google.maps.event.addListener(map, "click", () => {
    infoWindow.close();
  });
}

function geocodeAddress(geocoder, resultsMap, addressObj, index, callback) {
  geocoder.geocode({ address: addressObj.location }, (results, status) => {
    if (status === "OK") {
      const marker = new google.maps.Marker({
        position: results[0].geometry.location,
        map: map,
      });
      markers[index] = marker;

      google.maps.event.addListener(marker, "click", () => {
        infoWindow.setContent(`
          <div class="info-container">
            <span class="dealer-name">${addressObj.dealerName}</span><br>
            <strong>Phone:</strong> ${addressObj.phoneNumber}<br>
            <strong>Address:</strong> ${addressObj.location}<br>
            <strong>Email:</strong> <a href="mailto:${addressObj.email}">${addressObj.email}</a><br>
            <strong>Website:</strong> <a href="${addressObj.website}" target="_blank">${addressObj.website}</a>
          </div>
        `);
        infoWindow.open(map, marker);
      });

      if (callback) callback(marker);
    } else {
      console.error(
        "Geocode was not successful for the following reason: " + status
      );
    }
  });
}

function clearMarkers() {
  markers.forEach((marker) => {
    if (marker) {
      marker.setMap(null);
    }
  });
  markers = [];
}

function addAddresses(addresses) {
  clearMarkers(); // Clear existing markers
  const geocoder = new google.maps.Geocoder();
  const addressList = document.getElementById("address-list");
  addressList.innerHTML = ""; // Clear any existing addresses

  addresses.forEach((addressObj, index) => {
    const address = addressObj.location;
    const dealerName = addressObj.dealerName;

    // Create address list item
    const addressItem = document.createElement("div");
    addressItem.className = "address-item selected";
    addressItem.dataset.index = index;

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.checked = true;
    checkbox.style.pointerEvents = "none"; // Disable pointer events on the checkbox itself

    const dealerNameSpan = document.createElement("span");
    dealerNameSpan.className = "dealer-name";
    dealerNameSpan.textContent = dealerName;

    const addressTextSpan = document.createElement("span");
    addressTextSpan.className = "address-text";
    addressTextSpan.textContent = ` - ${address}`;

    addressItem.appendChild(checkbox);
    addressItem.appendChild(dealerNameSpan);
    addressItem.appendChild(addressTextSpan);
    addressList.appendChild(addressItem);

    // Geocode address and add marker
    geocodeAddress(geocoder, map, addressObj, index, () => {
      // Adjust map to fit markers after all markers are added
      if (index === addresses.length - 1) {
        adjustMapToFitMarkers();
      }
    });

    // Add click event listener to the address item
    addressItem.addEventListener("click", function () {
      const itemIndex = addressItem.dataset.index;
      if (checkbox.checked) {
        markers[itemIndex].setMap(null);
        checkbox.checked = false;
        addressItem.classList.remove("selected");
      } else {
        markers[itemIndex].setMap(map);
        map.setCenter(markers[itemIndex].getPosition());
        map.setZoom(Math.min(map.getZoom(), 12)); // Max zoom level to city level
        checkbox.checked = true;
        addressItem.classList.add("selected");
      }
      adjustMapToFitMarkers();
    });
  });
}

function adjustMapToFitMarkers() {
  const bounds = new google.maps.LatLngBounds();
  let visibleMarkers = 0;

  markers.forEach((marker) => {
    if (marker.getMap()) {
      bounds.extend(marker.getPosition());
      visibleMarkers++;
    }
  });

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds);
    if (visibleMarkers === 1) {
      map.setZoom(Math.min(map.getZoom(), 12)); // Max zoom level to city level
    }
  }
}

function filterAddressesByCountry(country) {
  if (country === selectedCountry) {
    return; // Prevent re-triggering the same filter
  }

  selectedCountry = country;
  if (country === "all") {
    addAddresses(addresses);
  } else {
    const filteredAddresses = addresses.filter(
      (address) => address.country === country
    );
    addAddresses(filteredAddresses);
  }
}

function extractCountry(location) {
  const match = location.match(/\(([^)]+)\)$/);
  return match ? match[1] : "Unknown";
}

function isValidFullAddress(address) {
  // A valid full address should contain at least 3 parts when split by commas
  const parts = address.split(",");
  return parts.length >= 3;
}

function loadExcelFile(url) {
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }
      return response.arrayBuffer();
    })
    .then((data) => {
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Extract relevant data
      addresses = rows
        .slice(1)
        .map((row) => ({
          dealerName: row[0] ? row[0].trim() : "", // DEALER NAME column
          website: row[1] ? row[1].trim() : "", // WEBSITE column
          location: row[2] ? row[2].trim() : "", // LOCATION column
          email: row[4] ? row[4].trim() : "", // EMAIL column
          phoneNumber: row[5] ? row[5].trim() : "", // PHONE # column
          country: row[2] ? extractCountry(row[2].trim()) : "", // Extract country from LOCATION column
        }))
        .filter((address) => isValidFullAddress(address.location)); // Filter out incomplete addresses

      addAddresses(addresses);
    })
    .catch((error) => console.error("Error loading Excel file:", error));
}

document.addEventListener("DOMContentLoaded", () => {
  // Load addresses from the provided URL
  const excelFileUrl =
    "https://docs.google.com/spreadsheets/d/1MW6eAiioakQA5wbS1ysIYZdEajZI6tOOQqYE9Z0QSEY/export?format=xlsx";
  loadExcelFile(excelFileUrl);

  // Add event listeners for filter buttons
  const filterButtons = document.querySelectorAll(".filter-button");
  filterButtons.forEach((button) => {
    button.addEventListener("click", function () {
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      const selectedCountry = this.dataset.country;
      filterAddressesByCountry(selectedCountry);
    });
  });
});
